import type { AuditDetailDialogProps } from "./types-audit-detail-dialog";
import { useAuditDetailDialog } from "./use-audit-detail-dialog";
import { AuditDetailDialogView } from "./view-audit-detail-dialog";

/** Modal "Detalhes da Auditoria" (HU 834), somente leitura. */
export function AuditDetailDialog(props: AuditDetailDialogProps) {
  const vm = useAuditDetailDialog(props);

  return <AuditDetailDialogView {...vm} />;
}

export type * from "./types-audit-detail-dialog";
